import classNames from "classnames";
import React from "react";
import InPluginInput from "../InPluginInput";
import styles from "../statics/styles/image-viewer.rtlignore.scss";
const EditorImageCaption = ({
  onCaptionChange,
  imageType,
  caption
}) => {
  if (!caption) return null;
  const isLinkImage = imageType === "link" || imageType === "anchor";
  const classes = classNames(styles.imageCaption, { [styles.link]: isLinkImage });
  return /* @__PURE__ */ React.createElement(InPluginInput, { className: classes, value: caption, onChange: onCaptionChange });
};
export {
  EditorImageCaption
};
//# sourceMappingURL=editor-image-caption.js.map
